var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M24 0.5H0V24.5H24V0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.001 18.5V21.5C11.001 22.05 10.551 22.5 10.001 22.5C9.45098 22.5 9.00098 22.05 9.00098 21.5V18.5H11.001Z",
    fill: "#04326B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.5V21.5C15 22.05 14.55 22.5 14 22.5C13.45 22.5 13 22.05 13 21.5V18.5H15Z",
    fill: "#04326B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M17 11.5V16.5C17 17.6 16.1 18.5 15 18.5H9C7.9 18.5 7 17.6 7 16.5V11.5C7 10.4 7.9 9.5 9 9.5H15C16.1 9.5 17 10.4 17 11.5Z",
    fill: "#04326B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.5V15.5C5 16.05 4.55 16.5 4 16.5C3.45 16.5 3 16.05 3 15.5V11.5C3 10.95 3.45 10.5 4 10.5C4.55 10.5 5 10.95 5 11.5Z",
    fill: "#04326B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.001 11.5V15.5C21.001 16.05 20.551 16.5 20.001 16.5C19.451 16.5 19.001 16.05 19.001 15.5V11.5C19.001 10.95 19.451 10.5 20.001 10.5C20.551 10.5 21.001 10.95 21.001 11.5Z",
    fill: "#04326B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.59998 8.1H14.4C15.28 8.1 16 7.38 16 6.5C16 4.29 14.21 2.5 12 2.5C9.79 2.5 8 4.29 8 6.5C8 7.38 8.71998 8.1 9.59998 8.1Z",
    fill: "#04326B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.5524875f592a41ba66d7eb61e6257ab7.svg";
export { ForwardRef as ReactComponent };